import { ColorTokens, ProgressIndicatorTypeTokens, } from '@voltmoney/schema';
import { progessIndicatorTypeTokensMap as progessIndicatorTypeTokensMapLight } from '../../light-mobile/progressIndicator';
export const progessIndicatorTypeTokensMap = {
    [ProgressIndicatorTypeTokens.default]: {
        ...progessIndicatorTypeTokensMapLight[ProgressIndicatorTypeTokens.default],
        color: ColorTokens.Blue_300,
    },
    [ProgressIndicatorTypeTokens.LINEAR]: {
        ...progessIndicatorTypeTokensMapLight[ProgressIndicatorTypeTokens.default],
        color: ColorTokens.Secondary_100,
    },
};
